import React from 'react';
import BondDeptListContainer from '../../containers/bond_dept/BondDeptListContainer';

const BondDeptListPage = () => {
  return <BondDeptListContainer />;
};

export default BondDeptListPage;
